export class LogoutError extends Error {
    constructor(message: string | undefined) {
        super(message)
        this.name = this.constructor.name
        Object.setPrototypeOf(this, LogoutError.prototype);
    }
}